import { styled, keyframes } from 'styled-components'

const popIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`

export const PuzzleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 100%;

  img {
    max-width: 100%;
  }
`

export const PuzzleCanvasWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
`

export const PuzzleCanvas = styled.div<{ $hidden: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  max-width: 100%;
  overflow: hidden;
  touch-action: none;
  border-radius: 8px;
`

export const SolvedImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  border-radius: 8px;
  outline: 4px solid #34b076;
`

export const SolvedBanner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 12px 40px;
  border-radius: 8px;
  background-color: rgba(52, 176, 118, 0.92);
  color: white;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: ${popIn} 0.4s ease-out;
`

export const BannerClose = styled.button`
  position: absolute;
  top: 2px;
  right: 6px;
  padding: 0 4px;
  border: none;
  background: none;
  color: inherit;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  pointer-events: auto;
`

export const TimerDisplay = styled.div`
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #333;
`

export const ButtonRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`